// Lib
import MobileDetect from 'mobile-detect';

export interface UseDeviceReturn {
  device: MobileDetect | Record<string, never>;
  platform: string;
}

// API: https://hgoebl.github.io/mobile-detect.js/doc/MobileDetect.html
const useDevice = (): UseDeviceReturn => {
  let md: MobileDetect | Record<string, never> = {};
  let platform = '';

  if (typeof window === 'object') {
    md = new MobileDetect(window.navigator.userAgent);
    platform = window.navigator.platform;
  }

  return { device: md, platform };
};

export default useDevice;
